import HoldingImage from './holding-image.component'

export default HoldingImage
